import * as React from "react";
import Search from "antd/lib/input/Search";
import { LocaleService } from "../../service/locale/LocaleService";
import { Form } from "antd";

export interface State {
  inputSearchValue?: string;
}

export interface Props {
  onSearch: (caseNumber: string) => void;
  searchOnBlur?: boolean;
  defaultValue?: string;
}

export default class CourtCaseNumberInput extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ...props,
      inputSearchValue: undefined
    };
  }
  render() {
    const { onSearch, searchOnBlur, defaultValue } = this.props;
    const { inputSearchValue } = this.state;
    return (
      <Form.Item name={defaultValue}>
        <Search
          onSearch={() => {
            inputSearchValue && onSearch(inputSearchValue);
          }}
          defaultValue={defaultValue}
          onBlur={() =>
            searchOnBlur && inputSearchValue
              ? onSearch(inputSearchValue)
              : undefined
          }
          onChange={(event) => {
            this.setState({
              inputSearchValue: LocaleService().transliterate(
                event.target.value
              )
            });
          }}
        />
      </Form.Item>
    );
  }
}
